/**
 * PDP media component
 *
 * @module product-media
 * @version 2.0.0
 * @extends HTMLElement
 */

class productMediaComponent extends HTMLElement {
  constructor() {
    super();
    this.initialVariantTitle =
      this.getAttribute("data-variant-title").toUpperCase();

    let variantTitle;
    variantTitle = this.initialVariantTitle;

    // Media element.
    this.media = this.querySelector("[data-media]");

    // Thumbnails element.
    this.thumbnails = this.querySelector("[data-thumbnail-slider]");

    this.initSlider(variantTitle);
    this.isVariantChanged = 0;
    this.isThumbnailChanged = 0;
  }

  connectedCallback() {
    window.addEventListener("variant-change", (event) => {
      if (event.detail.product.id == parseInt(this.dataset.productMediaId)) {
        this.updateMedia(event.detail.product, event.detail.variant);
      }
      this.isVariantChanged = 1;
      this.isThumbnailChanged = 0;
    });

    window.addEventListener("variant-change", (event) => {
      setTimeout(() => {
        document
          .querySelector(
            `.product-media__product-thumbnails .product-media__thumbnails-item[style="display: block;"] img`
          )
          .click();
        this.updateMainSlider();
      }, 300);
    });
  }

  // Initialize the media slider.
  initSlider(variantTitle) {
    this.slider = new Swiper(this.media, {
      // preloadImages: true,
      // lazy: true,
      lazyPreloadPrevNext: 1,
      autoHeight: true,
      slidesPerView: "auto",
      loop: false,
      pagination: {
        el: ".swiper-media-pagination",
        // dynamicBullets: true,
      },
    });

    this.thumbnails.addEventListener("click", (event) => {
      this.isVariantChanged &&
        !this.isThumbnailChanged &&
        this.updateMainSlider();
      if (event.target.tagName === "IMG") {
        // Calculates the true visual index of the thumbnail in the list of visible thumbnails
        const index = Array.from(
          this.thumbnails.querySelectorAll(".product-media__thumbnails-item")
        )
          .filter((thumbnail) => thumbnail.style.display !== "none")
          .indexOf(event.target.closest("[data-thumbnail-item]"));
        const mainSliderEl = Array.from(
          document.querySelectorAll(".product-media__images .swiper-slide")
        ).filter(
          (thumbnail) =>
            Number(thumbnail.getAttribute("data-sliderIndex")) === index
        );
        const mainFixedIndex = Array.from(
          document.querySelectorAll(".product-media__images .swiper-slide")
        ).indexOf(mainSliderEl[0]);

        this.slider.slideTo(mainFixedIndex);
      }
    });

    const initialVariantTitle = this.getAttribute("data-variant-title");
    const productTitle = this.getAttribute("data-product-title");

    const defaultAlt = this.getCurrentAltForThumbnails(initialVariantTitle);
    // console.log(defaultAlt, initialVariantTitle, productTitle);

    this.updateThumbnailsVisibility(
      defaultAlt,
      initialVariantTitle,
      productTitle
    );
  }

  // processAltText(altText) {
  //   return altText
  //     .toUpperCase()
  //     .split(" ")
  //     .filter((word) => word !== "AB_TEST")
  //     .map((word) => word.replace(/[^a-zA-Z0-9. ]/g, " ").trim());
  // }

  updateMainSlider() {
    Array.from(
      document.querySelectorAll(".product-media__images .swiper-slide")
    )
      .sort(function (a, b) {
        return (
          Number(a.getAttribute("data-sliderIndex")) -
          Number(b.getAttribute("data-sliderIndex"))
        );
      })
      .forEach(function (item) {
        document
          .querySelector(".product-media__images .swiper-wrapper")
          .appendChild(item);
      });
    this.isThumbnailChanged = 1;
  }
  processAltText(altText) {
    return altText
      .toUpperCase()
      .split(" ")
      .filter((word) => word !== "AB_TEST")
      .map((word) => word.replace(/[^a-zA-Z0-9. ]/g, " ").trim())
      .flatMap((word) => word.split(" ")); // Further split by new spaces and flatten
  }

  getCurrentAltForThumbnails(variantTitle) {
    let currentAlt = null;
    console.log('currentAlt:', currentAlt);
    const thumbnailsList = Array.from(this.thumbnails.querySelectorAll("img"));

    for (let thumbnail of thumbnailsList) {
      const altText = thumbnail.getAttribute("alt") || "";
      console.log('alt text:', altText)

      if (thumbnail.hasAttribute("alt")) {
        const altWords = this.processAltText(altText);

        if (!altText || altText === variantTitle || altWords.length > 0) {
          return altText || this.media.dataset.productTitle;
        }
      }
    }
    // console.log("Thumbnails currentAlt:", currentAlt);
    return currentAlt;
  }

  preloadImages(images) {
    images.forEach((image) => {
      const img = new Image();
      img.src = image.src;
      img.alt = image.alt;
    });
  }

  // getCurrentAlt(product, variant) {
  //   const initialVariantTitle = this.getAttribute("data-variant-title");
  //   const productTitle = this.getAttribute("data-product-title");

  //   let currentAlt = null;

  //   if (product.media) {
  //     for (let image of product.media) {
  //       if (
  //         !image.alt ||
  //         image.alt.toUpperCase() === product.title.toUpperCase()
  //       ) {
  //         return image.alt || product.title;
  //       }
  //       console.log(" image.alt.toUpperCase()", image.alt.toUpperCase());
  //       if (variant) {
  //         const altText = image.alt.toUpperCase();
  //         // Apply the same replace and trim logic to altWords as used for variantOptions
  //         // const altWords = altText
  //         //   .toUpperCase()
  //         //   .split(" ")
  //         //   .filter((word) => word !== "AB_TEST")
  //         //   .map((word) =>
  //         //     word
  //         //       .replace(/[^a-zA-Z0-9.()]/g, " ")
  //         //       .replace(/\s+/g, " ")
  //         //       .trim()
  //         //   );
  //         const altWords = this.processAltText(altText);
  //         console.log("altWords", altWords);

  //         const variantOptions = [
  //           variant.option1,
  //           variant.option2,
  //           variant.option3,
  //         ]
  //           .filter(Boolean)
  //           .map((option) =>
  //             option
  //               .toUpperCase()
  //               .replace(/[^a-zA-Z0-9.()]/g, " ")
  //               .replace(/\s+/g, " ")
  //               .trim()
  //           );

  //         console.log("Variant Options:", variantOptions);
  //         if (
  //           altWords.every((word) =>
  //             variantOptions.some((opt) => opt.indexOf(word) !== -1)
  //           )
  //         ) {
  //           currentAlt = altText;
  //           break;
  //         }
  //       }
  //     }
  //   }
  //   console.log("Main media currentAlt:", currentAlt);
  //   return currentAlt;
  // }

  getCurrentAlt(product, variant) {
    const variantTitle = this.getAttribute("data-variant-title");
    const productTitle = this.getAttribute("data-product-title");

    let currentAlt = null;

    if (product.media) {
      for (let image of product.media) {
        const altText = image.alt ? image.alt.toUpperCase() : "";
        // console.log("Checking image alt:", altText);

        // Exclude images with just 'AB_TEST' as their alt text
        if (altText === "AB_TEST") {
          continue;
        }
        if (
          !image.alt ||
          image.alt.toUpperCase() === product.title.toUpperCase()
        ) {
          return image.alt || product.title;
        }

        const altWords = this.processAltText(altText);

        if (variant) {
          // console.log("altWords", altWords);

          const variantOptions = [
            variant.option1,
            variant.option2,
            variant.option3,
          ]
            .filter(Boolean)
            .map((option) =>
              option
                .toUpperCase()
                .replace(/[^a-zA-Z0-9.()]/g, " ")
                .replace(/\s+/g, " ")
                .trim()
            );

          // console.log("Variant Options:", variantOptions);
          if (
            altWords.every((word) =>
              variantOptions.some((opt) => opt.indexOf(word) !== -1)
            )
          ) {
            currentAlt = altText;
            break;
          }
        }
      }
    }
    // console.log("Main media currentAlt:", currentAlt);
    return currentAlt;
  }

  updateMedia(product, variant) {
    this.preloadImages(product.media);
    const variantTitle = variant.title.toUpperCase();

    const currentAlt = this.getCurrentAlt(product, variant);

    if (currentAlt) {
      // const filteredMedia = product.media.filter(
      //   (image) =>
      //     (image.alt && image.alt.toUpperCase() === currentAlt) ||
      //     !image.alt ||
      //     image.alt.toUpperCase() === product.title.toUpperCase() ||
      //     image.alt.toUpperCase() === variantTitle.toUpperCase()
      // );
      const filteredMedia = product.media
        .filter((image) => {
          // Split image.alt into an array of words
          const altWords = image.alt ? image.alt.toUpperCase().split(" ") : [];
          // console.log("Split altWords", altWords);

          // Check if alt text contains 'AB_TEST'
          const containsABTest = altWords.includes("AB_TEST");

          // Check if every word in altWords appears in currentAlt
          const isAltInCurrentAlt = altWords.every((word) =>
            currentAlt.includes(word)
          );

          return (
            isAltInCurrentAlt ||
            !image.alt ||
            image.alt.toUpperCase() === product.title.toUpperCase() ||
            image.alt.toUpperCase() === variantTitle.toUpperCase()
          );
        })
        .sort(function (a, b) {
          return a.position - b.position;
        });
      this.setMediaInSlider(filteredMedia);
    } else {
      this.setMediaInSlider(product.media);
    }

    this.updateThumbnailsVisibility(currentAlt, variantTitle, product.title);
  }

  updateThumbnailsVisibility(currentAlt, variantTitle, productTitle) {
    // console.log(
    //   "currentAlt:",
    //   currentAlt,
    //   "variantTitle:",
    //   variantTitle,
    //   "productTitle:",
    //   productTitle
    // );
    Array.from(
      this.thumbnails.querySelectorAll(".product-media__thumbnails-item")
    ).forEach((thumbnail, idx) => {
      const imgAlt = thumbnail.querySelector("img").getAttribute("alt") || "";

      if (imgAlt.toUpperCase().indexOf("AB_TEST") !== -1) {
        thumbnail.style.display = "none";
        return;
      }

      const altWords = this.processAltText(imgAlt);

      const isAllAltTextMatch = altWords.every(
        (word) => currentAlt.toUpperCase().indexOf(word) != -1
      );

      const isImgAltEmpty = !imgAlt;

      const imgAltMatchesVariantTitle =
        imgAlt.toUpperCase() === variantTitle.toUpperCase();

      const imgAltMatchesProductTitle =
        imgAlt.toUpperCase() === productTitle.toUpperCase();

      const condition =
        isAllAltTextMatch ||
        isImgAltEmpty ||
        imgAltMatchesVariantTitle ||
        imgAltMatchesProductTitle;

      if (
        isAllAltTextMatch ||
        !imgAlt ||
        imgAlt.toUpperCase() === variantTitle.toUpperCase() ||
        imgAlt.toUpperCase() === productTitle.toUpperCase()
      ) {
        thumbnail.style.display = "block";
      } else {
        thumbnail.style.display = "none";
      }
    });
  }

  setMediaInSlider(media) {
    this.slider.removeAllSlides();

    // Load each image and update the slider as soon as it's loaded
    media.forEach((image, index) => {
      const img = new Image();
      img.src = image.src;
      img.alt = image.alt;

      img.onload = () => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.setAttribute("data-sliderIndex", index);
        slide.appendChild(img);

        // Add Made In USA label for each image.
        this.appendMadeInUSALabel(slide);

        this.slider.appendSlide(slide);

        // Attach event listener to image click event
        img.addEventListener("click", () => {
          this.openPhotoSwipe(index, media);
        });

        // Update the slider for each loaded image
        this.slider.update();

        // Show the Swiper pagination after the first image is loaded
        if (index === 0) {
          const swiperPagination = this.media.querySelector(
            ".swiper-media-pagination"
          );
          if (swiperPagination) {
            swiperPagination.style.display = "block";
          }
        }
      };
    });
  }

  openPhotoSwipe(index, media) {
    let pswpElement = document.querySelectorAll(".pswp")[0];

    // Build items array based on the media provided
    let items = media.map((img) => {
      return { src: img.src, w: parseInt(img.width), h: parseInt(img.height) };
    });

    // Define PhotoSwipe options
    let options = {
      index: index, // Start on the slide that was clicked
      history: false, // If set to true the gallery will add a history record when PhotoSwipe is open. Works with URL change via hash (#) as well.
    };

    let gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  }
  // Add this new method
  appendMadeInUSALabel() {
    // console.log("starting appendMadeInUSALabel");
    const madeInUSADiv = document.createElement("div");
    madeInUSADiv.className = "made-in-use-label";

    const madeInUSASvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    madeInUSASvg.setAttribute("width", "117");
    madeInUSASvg.setAttribute("height", "20");

    const svgImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image"
    );
    svgImage.href.baseVal =
      "https://cdn.shopify.com/s/files/1/0857/4644/files/made_in_the_usa_image_label.svg?v=1679933211";
    svgImage.setAttributeNS(null, "width", "117");
    svgImage.setAttributeNS(null, "height", "20");

    madeInUSASvg.appendChild(svgImage);
    madeInUSADiv.appendChild(madeInUSASvg);

    // const slides = document.querySelectorAll(
    //   ".product-media__images .swiper-slide"
    // );
    const slides = document.querySelectorAll(
      'div[data-version="new"] .product-media__images .swiper-slide'
    );

    slides.forEach((slide) => {
      slide.prepend(madeInUSADiv);
    });
  }

  /**
   * Extracts the variant ID from the URL.
   *
   * @returns {string|null} The variant ID if it exists, otherwise null.
   */
  getVariantIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("variant");
  }
}

if (!customElements.get("component-product-media")) {
  customElements.define("component-product-media", productMediaComponent);
}
